import React from "react";
import { Redirect, Route } from "react-router-dom";

export const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={(props) =>
			localStorage.getItem("token") ? (
				<Component {...props} />
			) : (
				<Redirect
					to={{
						pathname: "/",
						state: { from: props.location },
					}}
				/>
			)
		}
	/>
);

// import React from "react";
// import { Navigate } from "react-router-dom";

// export const PrivateRoute = ({ children }) => {
// 	return localStorage.getItem("token") ? children : <Navigate to="/" replace />;
// };
